module.exports = __webpack_public_path__ + "static/media/parsons-logo.a13c4d14.svg";